'use client';

import { c as _c } from "react/compiler-runtime";
import { type KeenSliderHooks, type KeenSliderInstance } from 'keen-slider';
import { type MutableRefObject } from 'react';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
import { type CarouselProps } from './CarouselProps';
interface CarouselDotsProps {
  dotsStyle: CarouselProps['dotsStyle'];
  instanceRef: MutableRefObject<KeenSliderInstance<any, any, KeenSliderHooks> | null>;
  currentSlide: number;
  slides: any[];
}
export const CarouselDots = t0 => {
  const $ = _c(13);
  const {
    dotsStyle,
    instanceRef,
    currentSlide,
    slides
  } = t0;
  const {
    t
  } = useLocale("carousel");
  const t1 = dotsStyle?.position === "Outside Slider";
  const t2 = dotsStyle?.position === "Inside Slider";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("mt-16 flex justify-center gap-2 px-3", {
      "mt-8": t1,
      "mt-0": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== currentSlide || $[4] !== dotsStyle?.deselectedColor || $[5] !== dotsStyle?.selectedColor || $[6] !== instanceRef || $[7] !== slides || $[8] !== t) {
    t4 = slides.map((_, index) => <button key={index} aria-label={t("slide-number", {
      number: `${index + 1}`
    })} onClick={() => {
      instanceRef.current?.moveToIdx(index);
    }} className="size-3 rounded-full" style={{
      background: currentSlide === index ? dotsStyle?.selectedColor : dotsStyle?.deselectedColor
    }} />);
    $[3] = currentSlide;
    $[4] = dotsStyle?.deselectedColor;
    $[5] = dotsStyle?.selectedColor;
    $[6] = instanceRef;
    $[7] = slides;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};